




















import { Component, Prop, Vue } from "vue-property-decorator";
import { CPTState } from "@/models/cpt/CPTState";
@Component
/**
 * Displays a given state as badge
 */
export default class StateBadge extends Vue {
  /**
   * The identifier/name of the custom post type
   */
  @Prop({ required: true }) readonly state!: string | null;

  /**
   * possible cpt states
   */
  public states = CPTState;
}
